import getElementsByClassName from './getElementsByClassName';

const ADACompliantActionButton = function (container, adaClass, value) {
    var adaClass = getElementsByClassName(container, adaClass)[0];
    if (adaClass) {
        adaClass.setAttribute('aria-label', value);
        adaClass.title = value;
    }
};
export default ADACompliantActionButton;
